import { FC } from 'react'
import EmployeeModal from '@modals/EmployeeModal'
import ModalOnRoute from '@templates/ModalOnRoute'

const EmployeeModalOnRoute: FC = () => {
  return <ModalOnRoute Component={EmployeeModal} withoutCloseOnOutsideClick />
}

export default EmployeeModalOnRoute
